import React from "react";
import { Box, Skeleton } from "@mui/material";
import { tokens } from "../../theme/tokens";

export const TaskListSkeleton: React.FC = () => (
  <Box sx={{ py: "10px" }}>
    {[0, 1].map((g) => (
      <Box key={g} sx={{ mb: "6px" }}>
        <Box sx={{ px: "14px", pt: "8px", pb: "4px" }}>
          <Skeleton variant="text" width={52} height={12} sx={{ borderRadius: "4px" }} />
        </Box>
        {[0, 1, 2].map((r) => (
          <Box
            key={r}
            sx={{ display: "flex", alignItems: "center", gap: "8px", px: "14px", py: "7px" }}
          >
            <Skeleton variant="circular" width={8} height={8} sx={{ flexShrink: 0 }} />
            <Skeleton variant="text" sx={{ flex: 1 }} height={14} />
            <Skeleton variant="text" width={24} height={14} sx={{ flexShrink: 0 }} />
          </Box>
        ))}
      </Box>
    ))}
  </Box>
);

export const WorkspaceSkeleton: React.FC = () => (
  <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
    <Box
      sx={{
        px: "16px",
        py: "14px",
        borderBottom: `1px solid ${tokens.color.border.default}`,
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <Skeleton variant="text" width={200} height={18} />
    </Box>
    <Box
      sx={{
        flex: 1,
        px: "16px",
        py: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {[0, 1, 2, 3].map((i) => (
        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Skeleton variant="circular" width={8} height={8} sx={{ flexShrink: 0 }} />
          <Skeleton variant="text" sx={{ flex: 1 }} height={14} />
          <Skeleton
            variant="rectangular"
            width={80}
            height={24}
            sx={{ borderRadius: "6px", flexShrink: 0 }}
          />
        </Box>
      ))}
    </Box>
  </Box>
);

export const TimelineSkeleton: React.FC = () => (
  <Box sx={{ px: "18px", py: "8px", display: "flex", flexDirection: "column" }}>
    {[0, 1, 2, 3].map((i) => (
      <Box
        key={i}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          py: "6px",
          borderBottom: `1px solid ${tokens.color.border.default}`,
          "&:last-child": { borderBottom: "none" },
        }}
      >
        <Skeleton variant="circular" width={6} height={6} sx={{ mt: "5px", flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" height={14} sx={{ mb: "2px" }} />
          <Skeleton variant="text" width="50%" height={11} />
        </Box>
        <Skeleton variant="text" width={40} height={11} sx={{ flexShrink: 0 }} />
      </Box>
    ))}
  </Box>
);
